import { Component, Input } from '@angular/core';

@Component({
  selector: 'translate-string',
  templateUrl: './translate-string.html',
  standalone: false,
})
export class TranslateStringComponent {
  @Input()
  set key(value: string) {
    if (!value) {
      this.translateString = '';
      return;
    }

    const normalizedKey = value.trim();
    this.translateString = this.dynamicLabels[normalizedKey] ?? normalizedKey; // fallback to raw key
  }

  translateString: string = '';

  // Map of keys to translatable labels
  private readonly dynamicLabels: Record<string, string> = {
    FACE: $localize`:@@FACE:Face`,
    FULL_FACE: $localize`:@@FULL_FACE:Face`,
    FRONT_FACE: $localize`:@@FRONT_FACE:Front Face`,
    SIDE_FACE: $localize`:@@SIDE_FACE:Side Face`,
    LEFT_SIDE_FACE: $localize`:@@LEFT_SIDE_FACE:Left Side Face`,
    RIGHT_SIDE_FACE: $localize`:@@RIGHT_SIDE_FACE:Right Side Face`,
    LEFT_FACE: $localize`:@@LEFT_FACE:Left Face`,
    RIGHT_FACE: $localize`:@@RIGHT_FACE:Right Face`,
    HAIR: $localize`:@@HAIR:Hair`,
    HAIR_TOP: $localize`:@@HAIR_TOP:Hair Top`,
    HAIR_FRONT: $localize`:@@HAIR_FRONT:Hair Front`,
    BODY: $localize`:@@BODY:Body`,
    REPORT: $localize`:@@REPORT:Report`,
    DOCUMENT: $localize`:@@DOCUMENT:Document`,
    uploadedDocuments: $localize`:@@uploadedDocuments:Uploaded Documents`,
    uploadedDocument: $localize`:@@uploadedDocument:Uploaded Document`,
    noDocumentsUploaded: $localize`:@@noDocumentsUploaded:No Documents Uploaded`,
    viewUploadedDocuments: $localize`:@@viewUploadedDocuments:View Uploaded Documents`,
    OTHER: $localize`:@@OTHER:Other`,
    INVALID: $localize`:@@INVALID:Invalid`,
    KEEP_PHOTO: $localize`:@@KEEP_PHOTO:Keep Photo`,
    DELETE_PHOTO: $localize`:@@DELETE_PHOTO:Delete Photo`,
    DELETE: $localize`:@@DELETE:Delete`,
    CANCEL_ORDER: $localize`:@@CANCEL_ORDER:Cancel Order`,
    GOT_QUESTIONS: $localize`:@@GOT_QUESTIONS:Got questions?`,
    SEE_REVIEWS: $localize`:@@SEE_REVIEWS:See reviews`,
    SEND_PRODUCTS: $localize`:@@SEND_PRODUCTS:Send products`,
    WILL_ORDER_LATER: $localize`:@@WILL_ORDER_LATER:Will order later`,
    REGIMEN_NOT_HAPPY: $localize`:@@REGIMEN_NOT_HAPPY:Not happy with the regimen`,
    ORDER_MISTAKE: $localize`:@@ORDER_MISTAKE:Ordered by mistake`,
    COSTLY: $localize`:@@COSTLY:Too costly`,
    SOMETHING_ELSE: $localize`:@@SOMETHING_ELSE:Something else`,
    SUBMIT: $localize`:@@SUBMIT:Submit`,
    CANCEL: $localize`:@@CANCEL:Cancel`,
    OK: $localize`:@@OK:OK`,
    LOGOUT: $localize`:@@LOGOUT:Logout`,
    YES: $localize`:@@YES:Yes`,
    NO: $localize`:@@NO:No`,
    UPDATE_APP: $localize`:@@UPDATE_APP:Update App`,
    UPDATE_NOW: $localize`:@@UPDATE_NOW:Update Now`,
    UPDATE_CHROME: $localize`:@@UPDATE_CHROME:Update Chrome`,
    UPDATE_WEB_VIEW: $localize`:@@UPDATE_WEB_VIEW:Update Web View`,
    FEEDBACK: $localize`:@@FEEDBACK:Feedback`,
    BAD: $localize`:@@BAD:Bad`,
    GOOD: $localize`:@@GOOD:Good`,
    LATER: $localize`:@@LATER:Later`,
    RETRY: $localize`:@@RETRY:Retry`,
    RATE_APP: $localize`:@@RATE_APP:Rate App`,
    RATE_NOW: $localize`:@@RATE_NOW:Rate Now`,
    DARKSPOTS: $localize`:@@DARKSPOTS:Darkspots`,
    ACNE_OR_PIMPLE: $localize`:@@ACNE_OR_PIMPLE:Acne / Pimple`,
    DARK_CIRCLES: $localize`:@@DARK_CIRCLES:Dark Circles`,
    DULL_SKIN: $localize`:@@DULL_SKIN:Dull Skin`,
    MELASMA: $localize`:@@MELASMA:Melasma`,
    STRETCH_MARKS: $localize`:@@STRETCH_MARKS:Stretch Marks`,
    RASH: $localize`:@@RASH:Rash`,
    FUNGAL_INFECTION: $localize`:@@FUNGAL_INFECTION:Fungal Infection`,
    TINEA: $localize`:@@TINEA:Tinea`,
    DRY_SKIN: $localize`:@@DRY_SKIN:Dry Skin`,
    HAIRFALL: $localize`:@@HAIRFALL:Hairfall`,
    DANDRUFF: $localize`:@@DANDRUFF:Dandruff`,
    ITCHY_SCALP: $localize`:@@ITCHY_SCALP:Itchy Scalp`,
    DRY_HAIR: $localize`:@@DRY_HAIR:Dry hair`,
    SCALP_PSORIASIS: $localize`:@@SCALP_PSORIASIS:Scalp Psoriasis`,
    SKIN: $localize`:@@SKIN:Skin`,
    INVALID_PINCODE: $localize`:@@INVALID_PINCODE:Invalid Pincode`,
    PRODUCT_NOT_HAPPY: $localize`:@@PRODUCT_NOT_HAPPY:Not happy with the product`,
  };
}
